import React from 'react';
import PropTypes from 'prop-types';

const MarketClosedMessage = ({ marketGroup, isMarketOpen, openingLabel }) => {
    return (
        <>
            <span className={ 'font-weight-bold' }>{ marketGroup } Today</span>{ !isMarketOpen && `: ${openingLabel}` }
        </>
    );
};

MarketClosedMessage.propTypes = {
    marketGroup: PropTypes.string,
    isMarketOpen: PropTypes.bool,
    openingLabel: PropTypes.string,
};

MarketClosedMessage.defaultProps = {
    marketGroup: '',
    openingLabel: '',
    isMarketOpen: false,
};

export { MarketClosedMessage };
